/* lua.js generated code 0.3.0 */

var PropBagItem = require("clover/panel/component/bagpanel/PropBagItem")
var PROP_COUNT_PER_ROW = 4                  //  背包每行物品数
var BORDER_WIDTH = 0                       
var BORDER_HEIGHT = 50
var PROP_WIDTH = 136                        //  道具格宽
var PROP_HEIGHT = 145                       //  道具格高
//var PROP_MARGIN = 12                        //  道具各边距
var ITEM_POSX = -6
var ITEM_POSY = 6
var TIPBOX_OFFSET = 10
var MAX_NUM_PER_CEIL = 999                  //  每格堆叠最大数
var BagItemList = xClass("BagItemList", cc.Node)
BagItemList.prototype.ctor = function (listType, panel, emptyTip) {
    var self = this
    self.listType = listType
    self.panel = panel
    self.emptyTip = emptyTip
    cc.Node.prototype.ctor.call(self)
    self.scrollview = null
    self.scrollContentSize = null
    self.tipBox = null
    self.tileBg = table()
    self.bagItemData = table()
    self.bagItems = table()
    self.selectedIndex = null
    self.beginPosY = null
    self.isScroll = false
}
BagItemList.prototype.init = function () {
    var self = this
    self.registerTouchEvents()
    self.bagItemData = self.mergePropsForBag()
    self.scrollview = ccui.ScrollView.create()
    self.scrollview.setContentSize(self.getContentSize())
    self.scrollview.setPosition(cc.p(0, 0))
    self.scrollview.setDirection(ccui.ScrollViewDir.vertical)
    self.scrollview.setBounceEnabled(true)
    self.scrollview.setSwallowTouches(false)
    self.addChild(self.scrollview)
	
    self.emptyTip.removeFromParent()
	self.emptyTip.setPosition(self.convertToNodeSpace(self.emptyTip.convertToWorldSpace(cc.p(0, 0))))
	self.addChild(self.emptyTip)

    self.updateScrollViewHeight()
	
    self.refreshItemBg()
	self.refreshItems()

    self.tipBox = require("clover/panel/component/bagpanel/ItemTipPopout").create()
    self.tipBox.setVisible(false)
    self.tipBox.setAnchorPoint(cc.p(0.5, -1))
    self.tipBox.onUseButtonClicked = function () {
        self.onUseProp()
    }
    self.tipBox.onTouchOutside = function () {
        self.closeTipbox()
    }
    self.panel.addChild(self.tipBox, 999)
}
BagItemList.prototype.closeTipbox = function () {
    var self = this
    self.selectedIndex = null
    self.tipBox.close()
}
BagItemList.prototype.onUseProp = function () {
    var self = this
    var index = self.selectedIndex
    if (index == null) {
        return 
    }
    var data = self.bagItems[index].itemData
    var useItemId = data.itemId
    var rewardType = (MetaManager.getInstance().getPropMeta(useItemId) || table()).reward || 0
    if (rewardType === 3 && UserEnergy.getInstance().getEnergy()[0] >= UserEnergy.getInstance().getEnergyLimit()) {
        Toast.make(getText("energy.panel.energy.is.full"))
        return 
    }
    UserProp.getInstance().useProp(table([0, useItemId]), 0, null, function () {
        data.num = data.num - 1 
        self.closeTipbox()
        self.refreshItemList()
    }, function (err) {
        //todo : error control
    }, null, ModuleName.BAG)
}
//-判断是否需要重新生成物品列表
BagItemList.prototype.checkItemListDiff = function () {
    var self = this
    var newData = self.mergePropsForBag()
    var needRecreate = false
    for (var i = 1, itemType = self.bagItemData.typeItems[1]; itemType; i++, itemType = self.bagItemData.typeItems[i]) {
        let newItemType = newData.typeItems[i]
        if (newItemType.length != itemType.length) {
            needRecreate = true
            break
        } 
        
        for(var j=1; j < itemType.length;++j) {
            let v = itemType[j]
            let newItemData = newItemType[j]
            if (!newItemData.itemId === v.itemId || !newItemData.timelimit === v.timelimit || !newItemData.expireTime === v.expireTime) {
                needRecreate = true
                break
            }
        }

        if (needRecreate){
            break
        }
    }
    self.bagItemData = newData
    return needRecreate
}
BagItemList.prototype.refreshItemList = function () {
    var self = this
    if (self.checkItemListDiff()) {
        for (var k = 1, v = self.bagItems[1]; v; k++, v = self.bagItems[k]) {
            v.numLabel.removeFromParent(true)
            v.removeFromParent(true)
        }
        self.bagItems = table()
        self.updateScrollViewHeight()
        self.refreshItemBg()
        self.refreshItems()
    } else {
        for (var i = 1, v = self.bagItems[1]; v; i++, v = self.bagItems[i]) {
            v.updateItemNum()
        }
    }
}
//-刷新背包的格子数
BagItemList.prototype.refreshItemBg = function () {
    var self = this
	self.scrollview.removeAllChildren()
	self.tileBg = table()
	var nowHeight = 0
    var len = self.bagItemData.typeItems.length
	for (var i=1; i< len; ++i){
        let v = self.bagItemData.typeItems[i]
		if (v && v.length > 1) {
			var classify = cc.CSLoader.createNode("cocos/bag_classify1.csb")
			var rowCount = Math.ceil((v.length-1)/PROP_COUNT_PER_ROW)
			classify.setPosition(cc.p(self.scrollContentSize.width/2, self.scrollContentSize.height - nowHeight - BORDER_HEIGHT/2))
			self.scrollview.addChild(classify)
			classify.getChildByName("txt_classify1").setString(self.bagItemData.typeNames[i])
			nowHeight = nowHeight + BORDER_HEIGHT

			for (var rowIndex = 1; rowIndex <= rowCount; ++rowIndex) {
				let row = cc.CSLoader.createNode("cocos/bag_row.csb")
				row.setPosition(cc.p(self.scrollContentSize.width/2, self.scrollContentSize.height - nowHeight - PROP_HEIGHT/2))
				self.scrollview.addChild(row)
				nowHeight = nowHeight + PROP_HEIGHT
				for (var colIndex = 1; colIndex <= PROP_COUNT_PER_ROW;++colIndex){
					let item = row.getChildByName(tostring(colIndex))
					item.getChildByName("bag_infinite").setVisible(false)
					item.getChildByName("bag_expire").setVisible(false)
					item.getChildByName("bag_limited").setVisible(false)
					item.getChildByName("bag_guanqian").setVisible(false)
					item.getChildByName("bag_guannei").setVisible(false)
					item.getChildByName("num2").setVisible(false)
					if (colIndex + (rowIndex-1)*PROP_COUNT_PER_ROW < v.length){
						table.insert(self.tileBg, item)
                    }
                }
            }
        }
    }
}
BagItemList.prototype.refreshItems = function () {
    var self = this
	self.emptyTip.setVisible((self.tileBg.length <= 1))
	
	var idx = 1
    var typeItemLen = self.bagItemData.typeItems.length
    for (var t=1;t<typeItemLen;++t){
        var w = self.bagItemData.typeItems[t]
        var wlen = w.length
		for (var i=1;i<wlen;++i) {
            var v = w[i]
            if (self.tileBg[idx] == null){
                console.log("idx:"+idx)
            }
			var parent = self.tileBg[idx].getChildByName("icon")
			var icon = PropBagItem.create(self.tileBg[idx], idx, v)
			icon.setPosition(parent.getContentSize().width/2, parent.getContentSize().height/2)
			parent.addChild(icon)

			icon.onClickCallback = (index)=>{
				if ((!self.isScroll) && self.isItemVisible(index)) {
					self.onItemClick(index)
                }
            }
			table.insert(self.bagItems, icon)
			icon.createNumLabel()

			idx = idx + 1
        }
    }
}
BagItemList.prototype.updateScrollViewHeight = function () {
    var self = this
    var contentSize = self.getContentSize()
    var [typeCnt, rowCount] = self.getRowCount()
	var totalHeight = rowCount * (PROP_HEIGHT) + BORDER_HEIGHT * typeCnt
	self.scrollview.setInnerContainerSize(cc.size(contentSize.width, Math.max(contentSize.height, totalHeight)))
    self.scrollContentSize = self.scrollview.getInnerContainerSize()
}
BagItemList.prototype.isItemVisible = function (index) {
    var self = this
    var {x: posX, y: posY} = self.getItemPos(index)
    var {x: _, y: containerY} = self.scrollview.getInnerContainer().getPosition()
    var contentHeight = self.getContentSize().height
    var itemPosY = posY + containerY
    return itemPosY > 0 && itemPosY < contentHeight
}
BagItemList.prototype.getItemPos = function (index) {
    var self = this
    let parentNode2 = self.bagItems[index].getParent().getParent()
    let parentNode3 = parentNode2.getParent()
	let y = parentNode3.getPositionY()
	let x = parentNode2.getPositionX() + parentNode3.getPositionX()
	return ccp(x, y)
}
BagItemList.prototype.onItemClick = function (index) {
    var self = this
    self.bagItems[index].playSelectAnim()
    
	var {x, y}  = self.getItemPos(index)
	var col = x/(self.scrollContentSize.width/2) > 1 && 3 || 1

    var {x: _, y: scrollY} = self.scrollview.getInnerContainer().getPosition()
    scrollY = cc.clampf(scrollY, self.getContentSize().height - self.scrollContentSize.height, 0)
    var offsetX = 0
    if (col < 2) {
        offsetX = 40
        self.tipBox.setFlip(true)
    } else {
        offsetX = -40
        self.tipBox.setFlip(false)
    }
	var targetPos = cc.p(x + offsetX, y + TIPBOX_OFFSET + scrollY)
	self.tipBox.setPosition(self.panel.convertToNodeSpace(self.convertToWorldSpace(targetPos)))
    //self.tipBox.setPosition(cc.p(x + offsetX, y + TIPBOX_OFFSET + scrollY))
    self.tipBox.setItem(self.bagItems[index])
    self.tipBox.popout()
    //self.tipBox.setPosition(300, 300)
    self.selectedIndex = index
}
BagItemList.prototype.mergePropsForBag = function () {
    var self = this
    // 碎片道具
	if (self.listType == 2) {
		//return self.mergeBeachMarketShardForBag( ... )
    }
    //-- 道具
	else {
		return self.mergeNormalPropsForBag()
    }
}
BagItemList.prototype.mergeNormalPropsForBag = function () {
    var self = this
    var bagItemData = table()
	bagItemData.typeItems = table()
    table.insert(bagItemData.typeItems, table())
    table.insert(bagItemData.typeItems, table())
    table.insert(bagItemData.typeItems, table())
	bagItemData.typeNames = table()
    table.insert(bagItemData.typeNames, "无限道具")
    table.insert(bagItemData.typeNames, "限时道具")
    table.insert(bagItemData.typeNames, "普通道具")

	// 限时道具
    var timeProps = UserManager.getInstance().getAndUpdateTimeProps()
    isValid = function (itemId) {
        // body
        for (var k in GamePropIds) {
            var v = GamePropIds[k]
            if (itemId === v) {
                return true
            }
        }
    }
    for (var k in timeProps) {
        var v = timeProps[k]
		if (v.num > 0 && isValid(v.itemId)) {
			if (UserPropData.isBagInfiniteProp(v.itemId)) {
				table.insert(bagItemData.typeItems[1], {itemId : v.itemId, num : v.num, timelimit : true, expireTime : v.expireTime })
            }
			else{
				// 限时道具，不要堆叠在一起（后端会把同一时间过期的道具放一起返回）
				for (var i = 1; i <= v.num; ++i) {
					table.insert(bagItemData.typeItems[2], {itemId : v.itemId, num : 1, timelimit : true, expireTime : v.expireTime })
                }
            }
        } 
    }
	table.sort(bagItemData.typeItems[2], (a, b)=>{
		var aType = 99
        if (UserPropData.isBagPreLevelProp(a.itemId))
        {
            aType = 1
        }else if(UserPropData.isBagInLevelProp(a.itemId)){
            aType = 2
        }

		var bType = 99
        if (UserPropData.isBagPreLevelProp(b.itemId))
        {
            bType = 1
        }else if(UserPropData.isBagInLevelProp(b.itemId)){
            bType = 2
        }


		if (aType == bType) {
			if (a.itemId == b.itemId) {
				return a.expireTime < b.expireTime
            }
			else{
				return a.itemId < b.itemId
            }
        }
		else{
			return aType < bType
        }
    })

    var props = UserManager.getInstance().getPropRef()
    for (var k in props) {
        var v = props[k]
		if (v.getNum() > 0 && isValid(v.itemId)) {
			table.insert(bagItemData.typeItems[3], { itemId : v.itemId, num : v.getNum(), timelimit : false, expireTime : 0 }) 
        }
    }
    table.sort(bagItemData.typeItems[3], function (a, b) {
		var aType = 99
        if (UserPropData.isBagPreLevelProp(a.itemId))
        {
            aType = 1
        }else if(UserPropData.isBagInLevelProp(a.itemId)){
            aType = 2
        }

		var bType = 99
        if (UserPropData.isBagPreLevelProp(b.itemId))
        {
            bType = 1
        }else if(UserPropData.isBagInLevelProp(b.itemId)){
            bType = 2
        }
		aType = aType == 0 && 99 || aType
		bType = bType == 0 && 99 || bType
        if (aType === bType) {
            if (a.itemId === b.itemId) {
                return a.num > b.num
            } else {
                return a.itemId < b.itemId
            }
        } else {
            return aType < bType
        }
    })
    return bagItemData
}
BagItemList.prototype.mergeBeachMarketShardForBag = function(){

}
BagItemList.prototype.getRowCount = function () {
    var self = this
	var typeCnt = 0
	var rowCnt = 0
    for (var k=1; k<self.bagItemData.typeItems.length;++k) {
        var v = self.bagItemData.typeItems[k]
		if (v && v.length > 0) {
			typeCnt = typeCnt + 1
			rowCnt = rowCnt + Math.ceil(v.length / PROP_COUNT_PER_ROW)
        }
    }
    
	return [typeCnt, rowCnt]
}
var DISABLE_BUTTON_THRESHOLD = 10
BagItemList.prototype.registerTouchEvents = function () {
    var self = this
    function onTouchBegan(touch, event) {
        self.closeTipbox()
        self.isScroll = false
        self.beginPosY = self.scrollview.getInnerContainer().getPositionY()
        return true
    }
    function onTouchMoved(touch, event) {
        if (self.isScroll) {
            return 
        } else {
            posY = self.scrollview.getInnerContainer().getPositionY()
            if (Math.abs(posY - self.beginPosY) > DISABLE_BUTTON_THRESHOLD) {
                self.isScroll = true
            }
        }
    }
    function onTouchEnded(touch, event) { }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(false)
    listener.registerScriptHandler(onTouchBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    listener.registerScriptHandler(onTouchMoved, cc.Handler.EVENT_TOUCH_MOVED)
    listener.registerScriptHandler(onTouchEnded, cc.Handler.EVENT_TOUCH_ENDED)
    self.listener = listener
    cc.eventManager.addListener(listener, self)
    // var eventDispatcher = self.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listener, self)
}
BagItemList.prototype.cleanup = function () {
    var self = this
    cc.eventManager.removeListener(self.listener)
    self.listener = null
    cc.Node.prototype.cleanup.call(self)
}
module.exports = BagItemList
